import { toNumber } from './Utils';
import type { CommissionConfigurationSaveRow } from '../services/CommissionsConfigurationService';

export interface EditableCommissionInterval {
  fromMonth: string;
  toMonth: string;
  rate: string;
}

export interface EditableCommissionRowInput {
  productLineId: number;
  currencyId: number;
  calculationTypeId: number | null;
  expenseRateInput: string;
  intervalsInput: EditableCommissionInterval[];
}

const parseOptionalInteger = (value: string): number | null => {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const parsed = Number(trimmed.replace(/\./g, '').replace(',', '.'));
  return Number.isFinite(parsed) ? Math.trunc(parsed) : null;
};

const parseRateValue = (value: string): number | null => {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const parsed = toNumber(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
};

const isUsdCurrencyCode = (currencyCode: string): boolean => {
  const normalized = currencyCode.trim().toUpperCase();
  return normalized === 'USD' || normalized === 'DOLARES' || normalized === 'DÓLARES';
};

export const formatCommissionCurrencyDisplay = (currencyCode: string): string =>
  isUsdCurrencyCode(currencyCode) ? 'U$S' : '$';

export const mapEditableToSavePayload = (
  row: EditableCommissionRowInput,
): CommissionConfigurationSaveRow => ({
  productLineId: row.productLineId,
  currencyId: row.currencyId,
  calculationTypeId: row.calculationTypeId,
  expenseRate: parseRateValue(row.expenseRateInput),
  intervals: row.intervalsInput
    .map((interval) => ({
      fromMonth: parseOptionalInteger(interval.fromMonth),
      toMonth: parseOptionalInteger(interval.toMonth),
      rate: parseRateValue(interval.rate),
    }))
    .filter((interval) => interval.fromMonth != null && interval.rate != null)
    .map((interval) => ({
      fromMonth: interval.fromMonth as number,
      toMonth: interval.toMonth,
      rate: interval.rate as number,
    })),
});
